//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      amount: "0",
      ifshow: false, //控制弹窗
      ifshow2: true,
      msgTime: 0, //弹窗时间
      datalist: [],
      isname: '全部领取',  //前往使用   已被领取完
    
    };
  },
  methods: {
    //全部领取
    collect() {
      let that = this;

      if (that.isname=='全部领取') {
        that.$request.post("/couponDetail/getFullDisCouAll", {}).then(data => {
          if (data.code == 0) {
            that.ifshow2 = false;
            that.ifshow = true;

            //
            that.getCouponslist();
            that.msg = setTimeout(function() {
              that.ifshow = false;
              that.ifshow2 = true;
            }, 1500);
            that.isname = '前往使用';
          }
        });
      } else if(that.isname=='前往使用') {
        console.log("前往使用");
         this.$router.push({
          path:'../print'
        })

      }else{
       
         console.log("已被领取完");
      }
    },
    colse() {
      clearTimeout(this.msgTime);
      this.ifshow2 = true;
    },
    receive(item) {
      let that = this;
      //立即领取0   待使用1  已过期2  已领完3
      if (item.zt == "0") {
        console.log("立即领取");

        that.amount = item.amt;
        that.ifshow = true;
        that.msgTime = setTimeout(function() {
          that.ifshow = false;
        }, 1500);

        //
        this.$request
          .post("/couponDetail/getFullDisCou", {
            cid: item.id
          })
          .then(data => {
            console.log(data);
            if (data.code == 0) {
              item.title = "待使用";
              item.zt = "1";
              item.ifshow = true;

              this.getCouponslist();
            }
          })
          .catch(e => {
            console.log(e);
          });
      } else if (item.zt == "1") {
        console.log("待使用1");
    this.$router.push({
          path:'../print'
        })
        
      } else if (item.zt == "2") {
        console.log("已过期2");
        

      } else {
        console.log("已领完3");
         this.$vux.toast.show({
            type: 'text',
            text: '已领完'
          })
      }
    },
    init() {
      this.getCouponslist();
    },
    tcClose() {
      this.ifshow = false;
    },
    getCookie(name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) {
        // return unescape(arr[2]);
        return arr[2];
      } else {
        return null;
      }
    },
    getCouponslist() {
      this.$request
        .post("/couponDetail/getFullDisCouList", {
          orderId: this.$route.query.orderId
        })
        .then(data => {
          //处理
          this.datalist = [];

          var dataTime = Date.parse(new Date()) / 1000;
          for (var i = 0; i < data.obj.length; i++) {
            var nowdate = new Date(data.obj[i].endTime) / 1000; //把当前日期变成时间戳

            if (dataTime > nowdate) {
              //过期
              data.obj[i]["zt"] = "2";
              data.obj[i]["title"] = "已过期";
              if (data.obj[i].amt == 20) {
                data.obj[i]["img"] = require("../../assets/images/QB20.png");
              } else if (data.obj[i].amt == 50) {
                data.obj[i]["img"] = require("../../assets/images/QB50.png");
              } else if (data.obj[i].amt == 100) {
                data.obj[i]["img"] = require("../../assets/images/QB100.png");
              } else if (data.obj[i].amt == 200) {
                data.obj[i]["img"] = require("../../assets/images/QB200.png");
              } else if (data.obj[i].amt == 500) {
                data.obj[i]["img"] = require("../../assets/images/QB500.png");
              } else if (data.obj[i].amt == 1000) {
                data.obj[i]["img"] = require("../../assets/images/QB1000.png");
              }
            } else {
              //没有过期
              if (data.obj[i].surplusCount != "0") {
                //还有
                data.obj[i]["zt"] = "0";
                data.obj[i]["title"] = "待领取";
                if (data.obj[i].amt == 20) {
                  data.obj[i]["img"] = require("../../assets/images/Q20.png");
                } else if (data.obj[i].amt == 50) {
                  data.obj[i]["img"] = require("../../assets/images/Q50.png");
                } else if (data.obj[i].amt == 100) {
                  data.obj[i]["img"] = require("../../assets/images/Q100.png");
                } else if (data.obj[i].amt == 200) {
                  data.obj[i]["img"] = require("../../assets/images/Q200.png");
                } else if (data.obj[i].amt == 500) {
                  data.obj[i]["img"] = require("../../assets/images/Q500.png");
                } else if (data.obj[i].amt == 1000) {
                  data.obj[i]["img"] = require("../../assets/images/Q1000.png");
                }
              } else {
                //无剩余
                data.obj[i]["zt"] = "3";
                data.obj[i]["title"] = "已领完";
                if (data.obj[i].amt == 20) {
                  data.obj[i]["img"] = require("../../assets/images/QB20.png");
                } else if (data.obj[i].amt == 50) {
                  data.obj[i]["img"] = require("../../assets/images/QB50.png");
                } else if (data.obj[i].amt == 100) {
                  data.obj[i]["img"] = require("../../assets/images/QB100.png");
                } else if (data.obj[i].amt == 200) {
                  data.obj[i]["img"] = require("../../assets/images/QB200.png");
                } else if (data.obj[i].amt == 500) {
                  data.obj[i]["img"] = require("../../assets/images/QB500.png");
                } else if (data.obj[i].amt == 1000) {
                  data.obj[i][
                    "img"
                  ] = require("../../assets/images/QB1000.png");
                }
              }
            }
            data.obj[i]["ifshow"] = false;
            this.datalist.push(data.obj[i]);
          }

          if (this.getCookie("_token")) {
            //获取个人已领券
            this.$request
              .post("/couponDetail/getFullDisCouByUser", {})
              .then(data => {
                if (data.obj.length >= 6) {
                  this.isname = '前往使用';
                }
                for (var i = 0; i < data.obj.length; i++) {
                  for (var j = 0; j < this.datalist.length; j++) {
                    if (data.obj[i].couponId == this.datalist[j].id) {
                      this.datalist[j].title = "待使用";
                      this.datalist[j].zt = "1";
                      console.log("j", j);
                      if (this.datalist[j].amt == 20) {
                        this.datalist[
                          j
                        ].img = require("../../assets/images/Q20.png");
                      } else if (this.datalist[j].amt == 50) {
                        this.datalist[
                          j
                        ].img = require("../../assets/images/Q50.png");
                      } else if (this.datalist[j].amt == 100) {
                        this.datalist[
                          j
                        ].img = require("../../assets/images/Q100.png");
                      } else if (this.datalist[j].amt == 200) {
                        this.datalist[
                          j
                        ].img = require("../../assets/images/Q200.png");
                      } else if (this.datalist[j].amt == 500) {
                        this.datalist[
                          j
                        ].img = require("../../assets/images/Q500.png");
                      } else if (this.datalist[j].amt == 1000) {
                        this.datalist[
                          j
                        ].img = require("../../assets/images/Q1000.png");
                      }

                      this.datalist[j].ifshow = true;
                      break;
                    }
                  }
                }

    //计算-------------------------------------


var CouponsData1=[]
for(var i=0;i<this.datalist.length;i++){
    var isbools=false
         for(var j=0;j<data.obj.length;j++){
              if(this.datalist[i].id==data.obj[j].couponId){
                isbools=true
              }
         }
         if(!isbools){
            CouponsData1.push(this.datalist[i])

         }
}
var isbools2=false
for(var t=0;t<CouponsData1.length;t++){
    if(CouponsData1[t].surplusCount>0){
        isbools2=true
    }

}

if(isbools2){
     
   console.log('全部领取');
 
   this.isname='全部领取'
}else{
 
    if(data.obj.length==0){
      this.isname='已被领完'
   
    }else{
        this.isname='前往使用'
       
    }
   
}


  //计算-------------------------------------
















              });












          } else {
            console.log("请登录");
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  mounted() {
    this.init();
  },
  created() {},
  props: {},
  watch: {},
  components: {}
};



// WEBPACK FOOTER //
// ./src/views/collectCoupons/collectCoupons.vue